import classNames from "classnames";

export interface FooterProps {
  className?: string;
  children?: React.ReactNode;
}

const Footer: React.FC<FooterProps> = (props) => {
  return (
    <div className={classNames(`ucl-footer`, props.className)}>
      <div className="ucl-footer-children">{props.children}</div>
    </div>
  );
};

export default Footer;
